import api from './api';

export const listSubmissions = async (params = {}) => {
  const { data } = await api.get('/submissions', { params });
  return data;
};

export const createSubmission = async (payload) => {
  const formData = new FormData();
  Object.entries(payload || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (key === 'files' && Array.isArray(value)) {
      value.forEach((file) => formData.append('files', file));
    } else if (key === 'answers' && typeof value === 'object') {
      formData.append('answers', JSON.stringify(value));
    } else {
      formData.append(key, value);
    }
  });
  const { data } = await api.post('/submissions', formData);
  return data;
};

export const markSubmission = async (id, payload) => {
  const formData = new FormData();
  Object.entries(payload || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (key === 'feedbackFiles' && Array.isArray(value)) {
      value.forEach((file) => formData.append('feedback', file));
    } else {
      formData.append(key, value);
    }
  });
  const { data } = await api.put(`/submissions/${id}/mark`, formData);
  return data;
};

export default {
  listSubmissions,
  createSubmission,
  markSubmission,
};
